<template>
  <div>
    <FiltersForm
      has-phone-sheet
      :applied-filters="appliedFilters"
      :on-clear-filter="clearFilter"
      :has-filters="hasFilters"
      :is-skeleton-loading="isSkeletonLoading"
      :is-global-country-filter="false"
      @filter="onFilter"
      @clear="onClearFilters"
    >
      <template v-slot:phone-actions>
        <slot name="phone-actions" />
      </template>

      <v-text-field
        clearable
        v-model="search"
        type="search"
        :label="$t('search')"
        prepend-inner-icon="search"
      />

      <base-date-picker
        :date="dates"
        placeholder="Dates"
        :config="dateConfig"
        :on-change="onChangeDate"
      />

      <v-autocomplete
        clearable
        v-model="status"
        :items="filterStatuses"
        prepend-inner-icon="download_done"
        item-title="name"
        item-value="id"
        :label="$t('status')"
      />

      <v-autocomplete
        clearable
        v-model="role"
        :items="filterRoles"
        prepend-inner-icon="download_done"
        item-title="name"
        item-value="code"
        :label="$t('role')"
      />
    </FiltersForm>
  </div>
</template>

<script>
  import FiltersForm from './FiltersBase';
  import filterUrlSync from '@/mixins/filterUrlSync';
  import filterChips from '@/mixins/filterChips';

  export default {
    mixins: [filterUrlSync, filterChips],
    components: {
      FiltersForm,
    },
    props: {
      isSkeletonLoading: {
        type: Boolean,
        default: false,
      }
    },
    emits: ['clearFilters', 'filter'],
    data() {
      return {
        urlConfig: [
          { field: 'search', urlKey: 'search', type: 'string' },
          { field: 'dates', urlKey: 'dates', type: 'string' },
          // Both selects store the raw value (item-value), so no lookup is needed.
          { field: 'status', urlKey: 'status', type: 'number' },
          { field: 'role', urlKey: 'role', type: 'string' },
        ],
        dates: null,
        dateConfig: {
          mode: 'range',
        },
        search: null,
        status: null,
        role: null,
      };
    },
    computed: {
      filterChipFields() {
        return [
          { model: 'search', label: this.$t('search') },
          { model: 'dates', label: 'Dates' },
          {
            model: 'status',
            label: this.$t('status'),
            toChips: (status) => [{
              value: this.filterStatuses.find(({ id }) => id === status)?.name ?? status,
            }],
          },
          {
            model: 'role',
            label: this.$t('role'),
            toChips: (role) => [{
              value: this.filterRoles.find(({ code }) => code === role)?.name ?? role,
            }],
          },
        ];
      },
      filterStatuses() {
        return this.$store.getters['businessUsers/statuses'];
      },
      filterRoles() {
        return this.$store.getters['users/subRoles'];
      },
      hasFilters() {
        const {
          search,
          dates,
          role,
          status
        } = this;
        return !!search ||
          !!dates ||
          role !== null ||
          status !== null;
      },
    },
    methods: {
      onChangeDate(dates) {
        this.dates = dates;
      },
      onFilter() {
        const { search, dates, status, role } = this;

        this.syncFiltersToUrl();
        this.rememberAppliedFilters();

        this.$emit('filter', {
          search: search || null,
          date_filter: dates || null,
          status,
          role
        });
      },
      onClearFilters() {
        this.dates = null;
        this.search = null;
        this.status = null;
        this.role = null;

        this.clearFiltersUrl();
        this.forgetAppliedFilters();

        this.$emit('clearFilters');
      },
    },
  };
</script>

<style lang="scss">

</style>
